// API hosts of the local, dev and QA builds (the .env.* files other than production and
// australia_prod). An allowlist rather than "not production", so a new or misconfigured
// build fails closed and QA-only tools stay hidden.
const QA_API_HOSTS = [
  /^localhost$/,
  /^dev\d*-api\.surge-dev\.com$/,
  /^api\.surge-qa(-\d+)?\.com$/,
  /^api\.spectrum-australia\.com$/,
];

export const isQaEnvironment = (
  apiPath: string | undefined = process.env.VUE_APP_API_PATH,
  nodeEnv: string | undefined = process.env.NODE_ENV,
): boolean => {
  if (nodeEnv === "production") return false;
  let hostname: string;
  try {
    hostname = new URL(apiPath ?? "").hostname;
  } catch {
    return false;
  }
  return QA_API_HOSTS.some((pattern) => pattern.test(hostname));
};
